import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BlogListOptions, BloglistLayoutEnum, ContentElement, ContentElementEnum, GridCell, RowCell, Section, TestimonialLayoutEnum } from '../../models/sections-model';
import { animate, animateChild, keyframes, query, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'ngx-blog-list-renderer',
  templateUrl: './blog-list-renderer.component.html',
  styleUrls: ['./blog-list-renderer.component.scss'],
  animations: [
    trigger('animateText',[
      transition('* => animateSummaries',[
        // hide the inner elements
       query('.title', style({ opacity: 0 })),
       query('.details', style({ opacity: 0 })),

       // animate the inner elements in, one by one
       query('.title', animate(1000, style({ opacity: 1 }))),
       query('.details', animate(1000, style({ opacity: 1 }))),

       query('@zoomIn', animateChild())
      ])
    ]),
    trigger('zoomIn',[
      transition('* <=> *', [
        style({ opacity: 0, transform: 'scale(0)'}),
        animate(2000, style({ opacity: 1, transform: 'scale(1)' }))
      ])
    ]),
  ]
})
export class BlogListRendererComponent implements OnInit,AfterViewInit {
  @Input() data:Section;
  @Input() edit:boolean;
  @Input() title:string;

  blogListOptions:any;
  cells:any[];
  layoutClass:string;;
  blogSummaries:any;
  animateStart = '';

  wrapperClass:string;
  

  @Output() editUpdate = new EventEmitter<any>();
  @Output() createUpdate = new EventEmitter<RowCell>();

  constructor(private cdr: ChangeDetectorRef) { }
  ngAfterViewInit(): void {
    /* console.log(this.data)   
    this.layoutClass = this.data.layoutClass?this.data.layoutClass : BloglistLayoutEnum.SQUARE_IMG_Top;
    if(this.layoutClass == BloglistLayoutEnum.INSET_IMG_Top){
      console.log("Adding inset image")
      let host = <HTMLElement>this.classContainer.nativeElement;
      host.classList.add("inset-image");
      
    } */
  }

  ngOnInit(): void {
    console.log(this.data)
    //this.cells = this.data;
    this.blogListOptions = this.data.sectionData.blogListOptions;
    //this.title = this.data["title"];
    this.cells = this.blogListOptions["rowCells"];
    this.layoutClass = this.data.sectionData.layoutClass;
    this.wrapperClass = this.data.sectionData.wrapperClass?this.data.sectionData.wrapperClass:"solid";
    console.log(this.layoutClass);
    //this.blogSummaries = this.data.summaries;
    
    this.animateStart = 'animateSummaries';

    this.cells.forEach((rowCell) => {
      console.log("setDefaultContainerClasses")
      this.setDefaultContainerClasses(rowCell);
      //console.log(index+":"+rowCell.imgSrc);
    })
  }

  setDefaultContainerClasses(rowCell:RowCell):void{
    rowCell.contentElements.forEach(cntEl => {
      if(!cntEl.containerClasses){
        cntEl.containerClasses = [];
      }
      switch (this.getEnumValue(cntEl)) {
        case "header":
          cntEl["containerClasses"].push("header-container");
          break;
        case "summary":
          cntEl["containerClasses"].push("summary-container")
          break;
        case "image":
          cntEl["containerClasses"].push("image-container")
          break;
        case "date":
          cntEl["containerClasses"].push("date-container")
          break;
        case "byline":
          cntEl["containerClasses"].push("byline-container")
          break;
        default:
          break;
      }
      console.log(cntEl) 
    })
  }

  createContent(cell:GridCell|RowCell){
    console.log(cell)
    this.createUpdate.emit(cell);
  }
  updateSection(section:Section){
    console.log(section);
    this.data = section;
    this.cells = section.sectionData.blogListOptions.rowCells;
    //console.log(this.cells);
    this.cdr.detectChanges();
  }
  /**
   * 
   * ContentElementEnum.HEADER = "header"
   * ContentElementEnum.SUMMARY = "summary"
   * ContentElementEnum.IMAGE = "image"
   * ContentElementEnum.DATE = "date"
   * ContentElementEnum.BYLINE = "byline"
   * 
   * @param contentElement 
   * @returns 
   */
  getEnumValue(contentElement:ContentElement){
    let enumValue:string;
    let titleEnum = contentElement.contentElementEnum
    if(titleEnum != undefined){
      if((titleEnum).includes(".")){
        let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
        enumValue = ContentElementEnum[enumKey];
      }else if(ContentElementEnum[titleEnum] != undefined){
        enumValue = ContentElementEnum[titleEnum]
      }else{
        enumValue = titleEnum;
      }
    }
    //if(enumValue) enumValue = <string>enumValue.toUpperCase();
    console.log()
    return enumValue;
    /* console.log(titleEnum)
    let title;
    if((titleEnum).includes(".")){
      let enumKey = titleEnum.split('.')[1] as keyof typeof ContentElementEnum;
      title = ContentElementEnum[enumKey];
    }else if(ContentElementEnum[titleEnum] != undefined){
      title = ContentElementEnum[titleEnum]
    }else{
      title = titleEnum;
    }
    console.log(title)
    return title */
  }

  

}
